var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterSliderThick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-filter-2",
    "data-name": "icon-filter",
    d: "M3,17.167a.947.947,0,0,0,.944.944H8.667V16.222H3.944A.947.947,0,0,0,3,17.167ZM3,5.833a.947.947,0,0,0,.944.944h8.5V4.889h-8.5A.947.947,0,0,0,3,5.833Zm9.444,13.222v-.944h6.611a.944.944,0,0,0,0-1.889H12.444v-.944a.944.944,0,1,0-1.889,0v3.778a.944.944,0,0,0,1.889,0ZM6.778,9.611v.944H3.944a.944.944,0,0,0,0,1.889H6.778v.944a.944.944,0,0,0,1.889,0V9.611a.944.944,0,0,0-1.889,0ZM20,11.5a.947.947,0,0,0-.944-.944h-8.5v1.889h8.5A.947.947,0,0,0,20,11.5ZM15.278,8.667a.947.947,0,0,0,.944-.944V6.778h2.833a.944.944,0,0,0,0-1.889H16.222V3.944a.944.944,0,1,0-1.889,0V7.722A.947.947,0,0,0,15.278,8.667Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSliderThick);
export default __webpack_public_path__ + "static/media/icon-filter-slider-thick.0b0d6ca6.svg";
export { ForwardRef as ReactComponent };